import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Tjek om der er kulsyre på kulsyreflasken
          </Heading1>
          <Paragraph>
            Sådan tjekker du nemt og hurtigt om der er kulsyre på kulsyreflasken
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="8zlzAMADWCc" thumbnail="kulsyre-tjek" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Sørg først for at kulsyreflasken er åben. Drej hele vejen mod uret og ca. en kvart omgang tilbage.
            Tag håndtaget af. Skub det ned i vandret, som hvis koblinen sad på fustagen og hør om der fiser kulsyre ud.
            Der er tydeligvis kulsyre tilbage i flasken.
            Vi viser det lige igen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
